import { jsx as t } from "react/jsx-runtime";
import r from "../../stack/v1/Stack.js";
const a = ({ children: a2, ...e }) => t(r, { "data-testid": e["data-testid"], direction: "row", ...e, children: a2 });
export {
  a as default
};
